import { Box } from '@mui/material'
import { GoogleLoginButton, googleUserAtom } from 'infrastructure/googleDrive'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { ImportStandards } from './ImportStandards'
import { ExportStandards } from './ExportStandards'
import { WeightedSkillsLists } from '../WeightedSkillsLists'
import React from 'react'

export function BulkAddStandardsV2({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const guser = useAtomValue(googleUserAtom)

  if (!guser.credential?.accessToken) {
    return (
      <Box>
        <GoogleLoginButton hideWhenLoggedIn={true} />
      </Box>
    )
  }

  return (
    <Box>
      <WeightedSkillsLists treeId={treeId} treeVer={versionId} />
      <ExportStandards treeId={treeId} treeVer={versionId} />
      <ImportStandards treeId={treeId} treeVer={versionId} />
    </Box>
  )
}
